import { render, staticRenderFns } from "./thbfx.vue?vue&type=template&id=ab43e7a4&scoped=true"
import script from "./thbfx.vue?vue&type=script&lang=js"
export * from "./thbfx.vue?vue&type=script&lang=js"
import style0 from "./thbfx.vue?vue&type=style&index=0&id=ab43e7a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab43e7a4",
  null
  
)

export default component.exports